import {useAuthStore} from "../store/user-store";
import {useEffect, useState} from "react";

export default function AboutPage() {
    const authStore=useAuthStore()
    const [settings, setSettings] = useState(JSON.parse(localStorage.getItem('settings')));


    return <>
        <div className={'container'}>
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className={'text-white'} dangerouslySetInnerHTML={{__html:settings.about }}></div>
                </div>
            </div>
        </div>
    </>
}